import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { Calendar } from 'lucide-react';
import type { FileRequest } from '@/types/api';
import { RequestStatusBadge } from './RequestStatusBadge';

export function RequestCard({ request }: { request: FileRequest }) {
  return (
    <Link
      to={`/requests/${request.id}`}
      className="block bg-white border border-slate-200 p-4 hover:border-bb-navy/40 hover:shadow-sm transition-colors"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="text-sm font-semibold text-slate-800 truncate">{request.title}</h3>
          {request.instructions && (
            <p className="text-xs text-slate-500 mt-1 line-clamp-2">{request.instructions}</p>
          )}
        </div>
        <RequestStatusBadge status={request.status} />
      </div>
      <div className="flex items-center gap-4 mt-3 text-xs text-slate-500">
        <span className="inline-flex items-center gap-1">
          {request.submitted_file_id ? 'File submitted' : 'Awaiting submission'}
        </span>
        {request.due_date && (
          <span className="inline-flex items-center gap-1">
            <Calendar size={14} />
            Due {format(new Date(request.due_date), 'PP')}
          </span>
        )}
      </div>
    </Link>
  );
}
